// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__EmLNE","title":"HeroContent_title__SSprz","description":"HeroContent_description__PJK4w","control":"HeroContent_control__PMatQ"};